// @flow
import { endOfMonth, format, parse, startOfMonth } from 'date-fns';
import React from 'react';

import type { DateRange, TransactionManagerTab } from './types';
import SelectDateRangeNullState from './SelectDateRangeNullState';
import TransactionManager from './TransactionManager';
import transactionManagerTabs from './transactionManagerTabs';

const dateFormat = 'YYYY-MM-DD';

const expandDateRangeToSpanWholeMonths = dateRange => {
  const endDateAtEndOfMonth =
    dateRange.endDate && format(endOfMonth(parse(dateRange.endDate)), dateFormat);
  const startDateAtStartOfMonth =
    dateRange.startDate && format(startOfMonth(parse(dateRange.startDate)), dateFormat);
  return {
    endDate: endDateAtEndOfMonth,
    startDate: startDateAtStartOfMonth,
  };
};

type TransactionManagerContainerProps = {
  dateRange?: DateRange,
  updateQueryParams: Object => void,
  search: string,
  tab?: TransactionManagerTab,
};

const TransactionManagerContainer = ({
  dateRange,
  updateQueryParams,
  search,
  tab,
}: TransactionManagerContainerProps) => {
  const fullDateRange = dateRange && expandDateRangeToSpanWholeMonths(dateRange);
  if (!fullDateRange || !fullDateRange.startDate || !fullDateRange.endDate) {
    return (
      <SelectDateRangeNullState
        description="Select a date range below in order to use the Transaction Manager."
        onRangeSelect={updateQueryParams}
        title="Transaction Manager"
      />
    );
  }
  if (!tab) {
    updateQueryParams({ tab: transactionManagerTabs.FOLLOW_UP });
  }
  return (
    <TransactionManager
      dateRange={fullDateRange}
      search={search}
      updateQueryParams={updateQueryParams}
      tab={tab}
    />
  );
};

TransactionManagerContainer.defaultProps = {
  dateRange: undefined,
  tab: undefined,
};

export default TransactionManagerContainer;
